import { App, defineAsyncComponent } from 'vue'

const iconsComp = require.context('@/components/icons/', true, /\.vue$/)

const install = (app: App<Element>): void => {
  for (const comp of iconsComp.keys()) {
    const name = comp.replace(/^\.\//, '').replace(/\.\w+$/, '')

    app.component(`Icon${name}`, defineAsyncComponent(() => import(`@/components/icons/${name}.vue`)))
  }
}

export default {
  install,
}
